export default {
  'wallet.headerTitle': 'Danh sách ví',
  'wallet.newWallet': 'Ví mới',
  'wallet.oldWallet': 'Ví cũ',
  'wallet.referralCode': 'Mã giới thiệu',
  'wallet.level': 'Level',
  'wallet.socialMapping': 'Social Mapping',
  'wallet.coweBalance': 'Số dư COWe',
  'wallet.survey': 'Khảo sát',
  'wallet.action': 'Thao tác',
  'wallet.copySuccess': 'Đã sao chép vào clipboard!',
  'wallet.level.all': 'Tất cả',
  'wallet.level.0': 'Level 0',
  'wallet.level.1': 'Level 1',
  'wallet.level.2': 'Level 2',
  'wallet.social.xLinked': 'Đã liên kết X',
  'wallet.social.xNotLinked': 'Chưa liên kết X',
  'wallet.social.tgVerified': 'Telegram (Đã xác thực)',
  'wallet.social.tgUnverified': 'Telegram (Chưa xác thực)',
  'wallet.social.tgNotLinked': 'Chưa liên kết Telegram',
  'wallet.social.gmailLinked': 'Đã liên kết Gmail',
  'wallet.social.gmailNotLinked': 'Chưa liên kết Gmail',
  'wallet.survey.all': 'Tất cả',
  'wallet.survey.done': 'Đã làm',
  'wallet.survey.notDone': 'Chưa làm',
  'wallet.survey.placeholder': 'Vui lòng chọn',
  'wallet.detailTelegram': 'Chi tiết MXH',
  'wallet.social.tab.x': 'X (Twitter)',
  'wallet.social.tab.telegram': 'Telegram',
  'wallet.social.tab.gmail': 'Gmail',
  'wallet.social.fullName': 'Họ và tên',
  'wallet.social.providerUserId': 'ID người dùng hệ thống',
  'wallet.social.status': 'Trạng thái',
  'wallet.social.createdAt': 'Ngày tạo',
  'wallet.social.metadata': 'Siêu dữ liệu',
  'wallet.social.email': 'Email',
  'wallet.social.phone': 'Số điện thoại',
  'wallet.social.verifiedAt': 'Ngày xác thực',
  'wallet.social.verified': 'Đã xác thực',
  'wallet.social.unverified': 'Chưa xác thực',
  'wallet.social.notLinked': 'Chưa liên kết',
  'wallet.detailUser': 'Chi tiết User',
};
